(function($){
	
	// var closeDropdown = function(){
	// 	$( this ).removeClass( 'over' );
	// 	$( this ).off( 'focusout', closeDropdown );	
	// 	$( this ).on( 'focusin', openDropdown );
	// };
	// 
	// var openDropdown = function(){
	// 	$( this ).addClass( 'over' );
	// 	$( this ).off( 'focusin', openDropdown );
	// 	$( this ).on( 'focusout', closeDropdown );
	// };
	
	var navHover = function(){
		$( '.default-navigation li.menu-item-has-children' ).hoverIntent({
			over: function( ){
				$(this).addClass( 'over' );
			},
			out: function( ){
				$(this).removeClass( 'over' );
			},
			timeout: 100
		});
		
		$( '.default-navigation li.menu-item-has-children > a' ).on( 'keydown', function( e ){
			// if the key pressed is enter open the sub nav, if the enter key is pressed again, open the link.
			// if the esc key is pressed close the sub nav.
			if ( e.keyCode == 13 && ! $( this ).parent().hasClass( 'over' ) ) {
				e.preventDefault();
				$( this ).parent().addClass( 'over' );
			} else if ( /^Esc(ape)?$/.test(e.key) ) {
				$( this ).parent().removeClass( 'over' );
			}
		});
		
	};
	
	var navOpen = false;
		
	let $returnfocus;
	let $firstFocus;
	var openNav = function(){
		
		navOpen = true;
		$returnfocus = document.activeElement;
		$( 'html' ).addClass( 'html-open-nav' );
		$( 'body' ).addClass( 'open-nav' );
		$( '#nav' ).attr( 'aria-hidden', 'false' );
		$firstFocus.focus();
	};
	
	var closeNav = function(){
		navOpen = false;
		$( '#nav' ).attr( 'aria-hidden', 'true' );
		$( 'html' ).removeClass( 'html-open-nav' );
		$( 'body' ).removeClass( 'open-nav' );
		$( 'li.show-subnav' ).removeClass( 'show-subnav' );
		$( 'ul.hidden-level').removeClass( 'hidden-level' );
		$returnfocus.focus();
	};
	
	var toggleNav = function( e ) {
		e.preventDefault();
	
		if ( navOpen ) {
			closeNav();
		} else {
			openNav();
		}
	};
	
	var toggleSubnav = function( e ) {
		e.preventDefault();
		
		var parentItem = $(this).closest('.menu-item-has-children');
		var subMenu = parentItem.find( '> ul' );
		var hiddenStatus = subMenu.attr( 'aria-hidden' );
		
		if ( hiddenStatus === 'false' ) {
			parentItem.toggleClass('show-subnav');
			parentItem.parent('ul').toggleClass('hidden-level');
			parentItem.find('> a').first().focus();
			setTimeout(function(){
				subMenu.attr( 'aria-hidden', 'true' );
			}, 250);
		}
		else if ( hiddenStatus === 'true' ) {
			subMenu.attr( 'aria-hidden', 'false' );
			subMenu.find( '> a' ).first().focus();
			setTimeout(function(){
				parentItem.toggleClass('show-subnav');
				parentItem.parent('ul').toggleClass('hidden-level');
			}, 10);
		}
	};
	
	$(document).ready(function(){
		navHover();
        
		$firstFocus = $( '#mobile-nav' ).find( 'a' ).first();
		document.body.addEventListener('focus', function(ev) {
			if (navOpen && !ev.target.closest('.offcanvas-menu')) {
				$firstFocus.focus();
			}
		}, {capture: true});
		
		document.addEventListener('keydown', function(ev) {
			if (navOpen && /^Esc(ape)?$/.test(ev.key)) {
				closeNav();
			}
		});
		$( 'a.menu-toggle, a.close-menu' ).on( 'click', toggleNav );
		
		$(".mobile-nav li.menu-item-has-children > a, li.back-btn-wrapper a.back-btn, li.menu-item-has-children a.faux-back-btn").on('click', toggleSubnav );
		
		
		$(".mobile-nav li.menu-item-has-children").each(function(){
			var link = $( '> a', this );
			var subList =  $( '> ul', this );
			var menuId = this.id;
			subList.attr('id', 'sub-' + menuId);
			var parentText = link.text();
			subList.find('ul li a span.crumbs').append( '/' +parentText );
			link.attr( 'href', '#sub-' + menuId );
			link.attr('aria-controls', 'sub-' + menuId);
			link.prepend( "<span class='sr-only'>View more links<span>");
		});
		
	});
	
})(jQuery);